import { Component, Renderer2 } from '@angular/core';
import { environment } from 'src/environments/environment';
import { IStation, Station } from './interfaces/station.interface';
import { StationService } from './services/station.service';
import { MetaService } from './services/meta.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  idStation: string = environment.idStation;
  audioUrl: string = environment.audioUrl || '';
  titleWeb: string = environment.name;
  imageFavicon: string = environment.imageStation;
  station: Station | null = null;
  skin: string = environment.skin;
  loading: boolean = true;
  error: boolean = false;

  constructor(
    private _stationService: StationService,
    private renderer: Renderer2,
    private _metaService: MetaService,
  ){
    this.renderer.addClass(document.body, `${this.skin}`);
    this._metaService.updateTitle(this.titleWeb);
    this._metaService.updateFavicon(this.imageFavicon);
    this.initializeApp();
  }

  initializeApp() {
    if(this.idStation){
      this._stationService.getStation(this.idStation).subscribe({
        next: (resp: IStation) => {
          this.station = resp.station;
        },
        error: (error) => {
          // Mensaje de error
        }
      });
    }
  }
}
